// src/components/core/MeetingRoute.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMeetingById } from '../../services/api';
import MeetingController from './MeetingController';
import { useAuth } from '../../hooks/useAuth';
import { useAlert } from '../../hooks/useAlert';

const MeetingRoute = ({ meetingId }) => {
    const navigate = useNavigate();
    const [meeting, setMeeting] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();
    // Destructure showAlert from the object provided by the context.
    const { showAlert } = useAlert();

    useEffect(() => {
        const fetchMeeting = async () => {
            if (!meetingId) {
                setLoading(false);
                return;
            }

            setLoading(true);
            try {

                const response = await getMeetingById(meetingId);
                if (response && response.data) {
                    setMeeting(response.data);

                } else {
                    // The call to showAlert is now stable and correct.
                    showAlert('Meeting not found or has expired.', 'error');
                }
            } catch (err) {
                console.error("Failed to fetch meeting:", err);
                showAlert('Failed to load meeting details. Please check the URL and try again.', 'error');
            } finally {
                setLoading(false);
            }
        };

        fetchMeeting();
    }, [meetingId, navigate, showAlert]);

    if (loading) {
        return <div className="flex justify-center items-center h-screen text-xl">Loading Meeting...</div>;
    }

    if (meeting) {
        return <MeetingController meeting={meeting} user={user} />;
    }

    return null;
};

export default MeetingRoute;
